import {ReactNode, useEffect, useState} from 'react';
import {Sidebar} from 'src/components/sidebar/Sidebar';
import {RootState} from 'src/store';
import {useSelector} from 'react-redux';
import {Outlet} from 'react-router-dom';
import Header from 'src/components/header/header';

interface LayoutProps {
    children?: ReactNode;
}

export const Layout = ({children}: LayoutProps) => {
    const [authProps] = [
        useSelector((state: RootState) => state.auth),
        useSelector((state: RootState) => state.userProfile),
    ];
    const [showSidebar, setShowSidebar] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            const isMobileView = window.innerWidth <= 768;
            if (isMobileView) {
                setShowSidebar(false);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (authProps.error != null) {
        return null;
    }

    const toggleSideBar = () => {
        const isMobileView = window.innerWidth <= 768;
        if (isMobileView) {
            setShowSidebar(!showSidebar);
        }
    };

    return (
        <div className={`flex h-screen`}>
            {showSidebar ? <Sidebar onCloseClick={toggleSideBar} /> : null}
            <div className='flex-grow overflow-y-auto transition-opacity'>
                {!showSidebar && <Header onBurgerClick={toggleSideBar} />}
                <Outlet />
                {children}
            </div>
        </div>
    );
};
